import React from 'react';
// h-12 -> h-5
const PushDiv: React.FC = (): React.ReactElement => {
	return <div className="mb-px h-5 w-full" />;
};

export default PushDiv;
